import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate, useLocation } from 'react-router-dom';

const MenuUniformesTiendaMulti = ({ link }) => {

    const navigate = useNavigate();
    const location = useLocation();


    const nestedMenuitems = [
        {
            label: 'Filtro',
            icon: 'pi pi-search',
            style: {
                textShadow: location.pathname === '/filtro/na' && '0 0 red',
                color: location.pathname === '/filtro/na' && '#9b2f3e !important',
                fontWeight: location.pathname === '/filtro/na' && '500',
                //textDecoration: location.pathname === '/filtro/na' && 'underline',
                textDecorationColor: location.pathname === '/filtro/na' && '#9b2f3e'
            },
            command: e => {
                navigate('/filtro/na');
            }
        },
       /*  {
            label: 'Pendientes CT',
            icon: 'pi pi-search',
            style: {
                textShadow: location.pathname === '/filtro-ct' && '0 0 red',
                color: location.pathname === '/filtro-ct' && '#9b2f3e !important',
                fontWeight: location.pathname === '/filtro-ct' && '500',
                //textDecoration: location.pathname === '/filtro-ct' && 'underline',
                textDecorationColor: location.pathname === '/filtro-ct' && '#9b2f3e'
            },
            command: e => {
                navigate('/filtro-ct');
            }
        }, */ {
            label: 'Pendientes',
            icon: 'pi pi-inbox',
            style: {
                textShadow: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/' ) && '0 0 red',
                color: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/') && '#9b2f3e !important',
                fontWeight: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/' ) && '500',
                //textDecoration: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/' ) && 'underline',
                textDecorationColor: (location.pathname === '/pendientes' || location.pathname === '/multientrega-scanner/${IdAlumno}/${IdEncEntrega}/${Folio}' || location.pathname.substring(0,9) === '/resumen/' ) && '#9b2f3e'
            },
            command: e => {
                navigate('/pendientes');
            }
        }, {
            label: 'Reportes',
            icon: 'pi pi-fw pi-cog',
            style: {
                textShadow: (location.pathname === '/reporte/corte-tienda' || location.pathname === '/reporte-general' ) && '0 0 red',
                color: (location.pathname === '/reporte/corte-tienda' || location.pathname === '/reporte-general' ) && '#9b2f3e !important',
                fontWeight: (location.pathname === '/reporte/corte-tienda' || location.pathname === '/reporte-general' ) && '500',
                //textDecoration: (location.pathname === '/reporte/corte-tienda' || location.pathname === '/reporte-general' ) && 'underline',
                textDecorationColor: (location.pathname === '/reporte/corte-tienda' || location.pathname === '/reporte-general' ) && '#9b2f3e'
            },
            items: [{
                label: 'Corte',
                icon: 'pi pi-fw pi-user-edit',
                command: e => {
                    navigate('/reporte/corte-tienda');
                }
            }, {
                label: 'General',
                icon: 'pi pi-fw pi-file-pdf',
                command: e => {
                    navigate('/reporte-general');
                }
            }]
        },
        {
            label: 'Vales',
            icon: 'pi pi-ticket',
            style: {
                textShadow: location.pathname === '/imprenta-vales' && '0 0 red',
                color: location.pathname === '/imprenta-vales' && '#9b2f3e !important',
                fontWeight: location.pathname === '/imprenta-vales' && '500',
                //textDecoration: location.pathname === '/imprenta-vales' && 'underline',
                textDecorationColor: location.pathname === '/imprenta-vales' && '#9b2f3e'
            },
            command: e => {
                navigate('/imprenta-vales')
            }
        }
    ];

    return (
        <div className="col-12" style={{ marginBottom: "15px" }}>
            <Menubar model={nestedMenuitems} className="surface-card"></Menubar>
        </div>
    );
}

export default MenuUniformesTiendaMulti;